import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import invoiceKeys from '@/api/queries/invoice/keyFactor';
import { graphql } from '@/gql';
import { GetInvoicesInput, PaginationInput } from '@/gql/graphql';

const GET_INVOICES = graphql(`
  query GetInvoices($input: GetInvoicesInput, $pagination: PaginationInput!) {
    invoices(input: $input, pagination: $pagination) {
      items {
        id
        publicId
        reference
        status
        createdAt
        dueAt
        quickbooksInvoiceId
        xeroInvoiceId
        totalValue {
          value
        }
        outstandingValue {
          value
        }
        project {
          id
          publicId
          reference
          archivedAt
          customer {
            id
            publicId
            name
          }
        }
      }
      totalCount
      offset
      limit
    }
  }
`);

const useGetInvoices = (variables: {
  input?: GetInvoicesInput;
  pagination: PaginationInput;
}) => {
  return useQuery({
    queryKey: invoiceKeys.list(variables),
    queryFn: () => gqlClient.request(GET_INVOICES, variables),
    placeholderData: keepPreviousData,
  });
};

export default useGetInvoices;
